import { render } from "./englishImproveUploadVideo.vue?vue&type=template&id=6de471ea&scoped=true"
import script from "./englishImproveUploadVideo.vue?vue&type=script&lang=js"
export * from "./englishImproveUploadVideo.vue?vue&type=script&lang=js"

import "./englishImproveUploadVideo.vue?vue&type=style&index=0&id=6de471ea&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6de471ea"]])

export default __exports__